module.exports = __webpack_public_path__ + "img/wljg009.f4944d0c.jpg";